<template>
  <div v-if="show" class="modal-backdrop">
    <v-card class="pa-5">
      <div class="pa-4 text-center">
        <span style="color: var(--text-color); font-size: 1.6em"
          >Risk Disclosure on Derivatives</span
        >
      </div>

      <v-card-text
        style="font-size: 1em; word-spacing: 0.05em; line-height: inherit">
        <div style="color: var(--text-color)">
          <ul class="bullet-points">
            <li>
              9 out of 10 individual traders in equity Futures and Options
              Segment, incurred net losses.
            </li>
            <li>
              On an average, loss makers registered net trading loss close to
              50,000.
            </li>
            <li>
              Over and above the net trading losses incurred, loss makers
              expended an additional 28% of net trading losses as transaction
              costs.
            </li>
            <li>
              Those making net trading profits, incurred between 15% to 50% of
              such profits as transaction cost.
            </li>
          </ul>
          <p style="margin-top: 8px">
            <a
              href="https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html"
              target="_blank"
              rel="noopener noreferrer"
              >SEBI study dated January 25, 2023 on Analysis of Profit and Loss
              of Individual Traders dealing in equity Futures and Options (F&O)
              Segment, wherein Aggregate Level findings are based on annual
              Profit/Loss incurred by individual traders in equity F&O during FY
              2021-22</a
            >
          </p>
        </div>
      </v-card-text>

      <v-card-actions class="justify-center">
        <button @click="proceed" style="font-size: 1em" class="primary-button">
          Proceed
        </button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true, // Control modal visibility
    };
  },
  methods: {
    proceed() {
      // Emit event to indicate that "Proceed" button is clicked
      this.$emit("proceed");
    },
  },
};
</script>
<style scoped>
.modal-backdrop {
  z-index: 999;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-card {
  max-width: 800px;
  font-family: "Gilroy-Medium" !important;
  border-radius: 16px;
}
a {
  color: #1976d2 !important;
}
</style>
